export const generateDebtTemplate = `
<!DOCTYPE html>
<html>
<head>
</head>
<body>
    <div class="debt-container">
        <h2 class="pdf-table-heading">Debt </h2>
        <div class="debt-grid">
            <div >
                <div class="debt-label">Lender</div>
                <div class="debt-value">{{lender}}</div>
            </div>
            <div >
                <div class="debt-label">Interest Rate</div>
                <div class="debt-value">{{interestRate}}</div>
            </div>
            <div >
                <div class="debt-label">Maturity</div>
                <div class="debt-value">{{maturity}}</div>
            </div>
            <div >
                <div class="debt-label">Outstanding Balance</div>
                <div class="debt-value">{{outstandingBalance}}</div>
            </div>
        </div>
    </div>
</body>
</html>
`;
